import { AbiItem } from 'web3-utils'

export default [
    {
        inputs: [
            {
                internalType: 'contract IERC20',
                name: '_paymentToken',
                type: 'address',
            },
            {
                internalType: 'address',
                name: '_backendAddress',
                type: 'address',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'constructor',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'address',
                name: '_sender',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'address',
                name: '_creator',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: '_amount',
                type: 'uint256',
            },
        ],
        name: 'Donation',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                components: [
                    {
                        internalType: 'address',
                        name: 'creator',
                        type: 'address',
                    },
                    {
                        internalType: 'uint8',
                        name: 'creatorReward',
                        type: 'uint8',
                    },
                    { internalType: 'address', name: 'maker', type: 'address' },
                    { internalType: 'address', name: 'taker', type: 'address' },
                    {
                        internalType: 'bool',
                        name: 'isFixedPrice',
                        type: 'bool',
                    },
                    { internalType: 'uint256', name: 'price', type: 'uint256' },
                    { internalType: 'uint256', name: 'extra', type: 'uint256' },
                    {
                        internalType: 'uint256',
                        name: 'itemId',
                        type: 'uint256',
                    },
                    {
                        internalType: 'contract IERC721',
                        name: 'itemContract',
                        type: 'address',
                    },
                ],
                indexed: false,
                internalType: 'struct AtomicMatcher.Order',
                name: 'order',
                type: 'tuple',
            },
        ],
        name: 'OrderMatched',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'previousOwner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'OwnershipTransferred',
        type: 'event',
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: 'address',
                        name: 'creator',
                        type: 'address',
                    },
                    {
                        internalType: 'uint8',
                        name: 'creatorReward',
                        type: 'uint8',
                    },
                    { internalType: 'address', name: 'maker', type: 'address' },
                    { internalType: 'address', name: 'taker', type: 'address' },
                    {
                        internalType: 'bool',
                        name: 'isFixedPrice',
                        type: 'bool',
                    },
                    { internalType: 'uint256', name: 'price', type: 'uint256' },
                    { internalType: 'uint256', name: 'extra', type: 'uint256' },
                    {
                        internalType: 'uint256',
                        name: 'itemId',
                        type: 'uint256',
                    },
                    {
                        internalType: 'contract IERC721',
                        name: 'itemContract',
                        type: 'address',
                    },
                ],
                internalType: 'struct AtomicMatcher.Order',
                name: 'order',
                type: 'tuple',
            },
            { internalType: 'bytes', name: 'buyerSignature', type: 'bytes' },
            { internalType: 'bytes', name: 'sellerSignature', type: 'bytes' },
        ],
        name: 'atomicMatch',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: '_feeAddress', type: 'address' },
            {
                internalType: 'address',
                name: '_backendAddress',
                type: 'address',
            },
        ],
        name: 'changeAddresses',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: '_to', type: 'address' },
            { internalType: 'uint256', name: '_amount', type: 'uint256' },
        ],
        name: 'donateToCreator',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'feeTakerAddress',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'owner',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'paymentToken',
        outputs: [
            { internalType: 'contract IERC20', name: '', type: 'address' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'renounceOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'newOwner', type: 'address' },
        ],
        name: 'transferOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
] as AbiItem[]
